import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAccountsListFilters: (): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/list-filters`);
  },
  /**
   * Get the all data for export the Accounts list without pagination
   * @param {any} query - Query parameters for exporting utility provider accounts
   * @returns {any} Promise containing exported utility provider data
   */
  exportData: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/export-utility`, {
      ...parameters,
    });
  },
  /**
   * Fetch single Accounts list with pagination
   * @param {any} query - The query
   */
  fetchOneAccounts: (query: string): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/${query}`, {});
  },
  /**
   * create the Utility provider account
   * @param {any} data - The data
   */
  createUtilityAccounts: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/`, parameters);
  },
  /**
   * Edit the Utility provider account
   * @param {any} id - Utility provider account ID
   * @param {any} data - Updated utility provider payload
   * @returns {any} Promise containing updated utility provider response
   */
  editUtilityAccounts: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/${id}`, {
      ...parameters,
    });
  },

  /**
   * Approved the account function
   * @param {any} id - Utility provider account ID
   * @param {any} data - Approval payload
   * @returns {any} Promise containing approval response
   */
  approvedAccounts: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/verify-account/${id}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Delete the account api call function
   * @param {any} id - Utility provider account ID
   * @returns {any} Promise containing delete response
   */
  deleteAccount: (id: string): Promise<any> => {
    return deleteRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/utility-provider/${id}`);
  },
};
